import { MouseEvent } from 'react';
import { StoreType } from 'core/models/Store';
import DeleteIcon from 'shared/Icons/DeleteIcon';

interface SpaceListProps {
  store: StoreType;
  openAddStore(store: number): void
  onDeleteStore(store: StoreType): void
}

export default function StoreCard({ store, openAddStore, onDeleteStore }: SpaceListProps) {

  function handleStoreDetail() {
    openAddStore(store.id)
  }

  function handleDelete(event: MouseEvent<HTMLDivElement>) {
    event.stopPropagation()
    onDeleteStore(store)
  }

  const storeSlug = store.name.split(' ').join('-').toLowerCase()
  const isStockAvailable = Boolean(store.isStockAvailable)
  const stockLabel = isStockAvailable ? 'In Stock' : 'Out of Stock'
  const stockClassName = isStockAvailable ? 'in-stock' : 'out-stock'

  return (
    <div className='space-card' onClick={handleStoreDetail} id={`${storeSlug}-card`}>
      <div className={`space-card-stock ${stockClassName}`}>{stockLabel}</div>
      <div className='space-card-actions' onClick={(event) => event.stopPropagation()}>
        <div className='delete-btn' onClick={handleDelete}>
          <DeleteIcon fontSize={18} color="#ffffff" />
        </div>
      </div>
      <img src={store.media.cardIcon || store.media.bannerImage}
        alt={store.name}
        className='space-card-image'
      />
      <div className='space-card-name'>
        <label className='space-card-text'>{store.name}</label>
      </div>
    </div >
  )
}
